import { createAsyncTypes } from 'store/utils';
import { Admin } from 'store/admins';

// State Key
export const KEY = 'auth';

// Action Types
export const types = {
  CHECK_STATUS: `${KEY}/CHECK_STATUS`,
  LOGIN: createAsyncTypes(`${KEY}/LOGIN`),
  UPDATE_CURRENT_ADMIN: createAsyncTypes(`${KEY}/UPDATE_CURRENT_ADMIN`),
  REQUEST_RESET_PASSWORD: createAsyncTypes(`${KEY}/REQUEST_RESET_PASSWORD`),
  RESET_PASSWORD: createAsyncTypes(`${KEY}/RESET_PASSWORD`),
  LOGOUT: `${KEY}/LOGOUT`,
  RESET_ACTION: `${KEY}/RESET_ACTION`,
  RESET_ERROR: `${KEY}/RESET_ERROR`
};

export interface AuthState {
  readonly error: string | null;
  readonly authenticating: boolean;
  readonly token: string | null;
  readonly admin: Admin | null;
  readonly action: {
    successful: boolean;
    error: string | null;
    pending: boolean;
  };
}

export interface LoginPayload {
  email: string;
  password: string;
}

export interface LoginRequest {
  type: typeof types.LOGIN.REQUEST;
  payload: LoginPayload;
}

export interface LoginError {
  type: typeof types.LOGIN.ERROR;
  payload: string;
}

export interface LoginPending {
  type: typeof types.LOGIN.PENDING;
  payload: boolean;
}

export interface LoginSuccess {
  type: typeof types.LOGIN.SUCCESS;
  payload: {
    token: string;
    admin: Admin;
  };
}

export type UpdateCurrentAdminPayload = Partial<Admin> & { id: string; password?: string };
export interface UpdateCurrentAdminRequest {
  type: typeof types.UPDATE_CURRENT_ADMIN.REQUEST;
  payload: UpdateCurrentAdminPayload;
}

export interface UpdateCurrentAdminError {
  type: typeof types.UPDATE_CURRENT_ADMIN.ERROR;
  payload: string;
}

export interface UpdateCurrentAdminPending {
  type: typeof types.UPDATE_CURRENT_ADMIN.PENDING;
  payload: boolean;
}

export interface UpdateCurrentAdminSuccess {
  type: typeof types.UPDATE_CURRENT_ADMIN.SUCCESS;
  payload: Admin;
}

export interface RequestResetPasswordRequest {
  type: typeof types.REQUEST_RESET_PASSWORD.REQUEST;
  payload: string;
}

export interface RequestResetPasswordError {
  type: typeof types.REQUEST_RESET_PASSWORD.ERROR;
  payload: string;
}

export interface RequestResetPasswordPending {
  type: typeof types.REQUEST_RESET_PASSWORD.PENDING;
  payload: boolean;
}

export interface RequestResetPasswordSuccess {
  type: typeof types.REQUEST_RESET_PASSWORD.SUCCESS;
}

export interface ResetPasswordRequest {
  type: typeof types.RESET_PASSWORD.REQUEST;
  payload: {
    token: string;
    password: string;
  };
}

export interface ResetPasswordError {
  type: typeof types.RESET_PASSWORD.ERROR;
  payload: string;
}

export interface ResetPasswordPending {
  type: typeof types.RESET_PASSWORD.PENDING;
  payload: boolean;
}

export interface ResetPasswordSuccess {
  type: typeof types.RESET_PASSWORD.SUCCESS;
}

export interface Logout {
  type: typeof types.LOGOUT;
}

export type AuthActionTypes =
  | LoginRequest
  | Logout
  | LoginSuccess
  | LoginError
  | LoginPending
  | UpdateCurrentAdminRequest
  | UpdateCurrentAdminPending
  | UpdateCurrentAdminSuccess
  | UpdateCurrentAdminError
  | RequestResetPasswordRequest
  | RequestResetPasswordPending
  | RequestResetPasswordSuccess
  | RequestResetPasswordError
  | ResetPasswordRequest
  | ResetPasswordPending
  | ResetPasswordSuccess
  | ResetPasswordError;
